/* Warmpeak theme JS */
(function () {
  'use strict';
  var W = window.Warmpeak || {};

  function formatMoney(cents) {
    var fmt = W.moneyFormat || '${{amount}}';
    cents = typeof cents === 'string' ? parseInt(cents.replace('.', ''), 10) : cents;
    function withDelims(n, decimals, thousands, dec) {
      var fixed = (n / 100).toFixed(decimals);
      var parts = fixed.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(dec);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* ---------- Mobile menu ---------- */
  function initMenu() {
    var nav = document.getElementById('MobileNav');
    if (!nav) return;
    var toggle = document.querySelector('[data-menu-open]');
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-menu-open]')) { nav.classList.add('is-open'); toggle && toggle.setAttribute('aria-expanded', 'true'); }
      if (e.target.closest('[data-menu-close]')) { nav.classList.remove('is-open'); toggle && toggle.setAttribute('aria-expanded', 'false'); }
    });
  }

  /* ---------- Gallery ---------- */
  function initGallery(root) {
    var slides = root.querySelector('[data-gallery-slides]');
    if (!slides) return null;
    var thumbs = root.querySelectorAll('[data-thumb]');
    function go(i) {
      var n = slides.children.length;
      i = (i + n) % n;
      slides.scrollTo({ left: slides.clientWidth * i, behavior: 'smooth' });
    }
    function current() { return Math.round(slides.scrollLeft / Math.max(1, slides.clientWidth)); }
    slides.addEventListener('scroll', function () {
      var c = current();
      thumbs.forEach(function (t, idx) { t.setAttribute('aria-current', idx === c ? 'true' : 'false'); });
    }, { passive: true });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.thumb, 10)); }); });
    var prev = root.querySelector('[data-gallery-prev]'), next = root.querySelector('[data-gallery-next]');
    prev && prev.addEventListener('click', function () { go(current() - 1); });
    next && next.addEventListener('click', function () { go(current() + 1); });
    return {
      goToMedia: function (mediaId) {
        var kids = Array.prototype.slice.call(slides.children);
        var idx = kids.findIndex(function (k) { return k.dataset.mediaId === String(mediaId); });
        if (idx > -1) go(idx);
      }
    };
  }

  /* ---------- Product section ---------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var gallery = initGallery(section);
    var idInput = section.querySelector('[data-variant-id]');
    var qtyInput = section.querySelector('[data-qty-input]');
    var addBtn = section.querySelector('[data-add-button]');
    var addLabel = section.querySelector('[data-add-label]');
    var addDefault = addLabel ? addLabel.textContent : W.strings.addToCart;
    var priceEl = section.querySelector('[data-price-current]');
    var compareEl = section.querySelector('[data-price-compare]');
    var badgeEl = section.querySelector('[data-price-badge]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var variant = product.variants.find(function (v) { return String(v.id) === idInput.value; }) || product.variants[0];

    function selectedOptions() {
      var opts = [];
      section.querySelectorAll('[data-variant-picker] fieldset').forEach(function (fs, i) {
        var checked = fs.querySelector('input:checked');
        opts[i] = checked ? checked.value : null;
        var label = section.querySelector('[data-option-label="' + i + '"]');
        if (label && checked) label.textContent = checked.value;
      });
      return opts;
    }

    function updateBundles() {
      section.querySelectorAll('[data-bundles] input').forEach(function (inp) {
        var q = parseInt(inp.dataset.qty, 10), d = parseInt(inp.dataset.discount, 10) || 0;
        var full = variant.price * q, disc = Math.floor(full * (100 - d) / 100);
        var ref = (variant.compare_at_price && variant.compare_at_price > variant.price) ? variant.compare_at_price * q : full;
        var el = inp.parentElement.querySelector('[data-bundle-price]');
        if (el) el.innerHTML = (ref > disc ? '<s>' + formatMoney(ref) + '</s>' : '') + '<span>' + formatMoney(disc) + '</span>';
      });
    }

    function render() {
      idInput.value = variant.id;
      if (priceEl) priceEl.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var onSale = !!(variant.compare_at_price && variant.compare_at_price > variant.price);
      if (compareEl) { compareEl.hidden = !onSale; compareEl.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      if (badgeEl) { badgeEl.hidden = !onSale; badgeEl.textContent = onSale ? 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%' : ''; }
      var stickyCompare = document.querySelector('[data-sticky-compare]');
      if (stickyCompare) { stickyCompare.hidden = !onSale; stickyCompare.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addLabel.textContent = variant.available ? addDefault : W.strings.soldOut;
      }
      updateBundles();
      if (variant.featured_media && gallery) gallery.goToMedia(variant.featured_media.id);
      if (history.replaceState && /\/products\//.test(location.pathname)) {
        var url = new URL(location.href); url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-option-index]')) {
        var opts = selectedOptions();
        var match = product.variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
        if (match) { variant = match; render(); }
      }
      if (e.target.matches('[data-bundles] input')) {
        qtyInput.value = e.target.dataset.qty;
      }
    });

    var preset = section.querySelector('[data-bundles] input:checked') || section.querySelector('[data-bundles] input');
    if (preset) { preset.checked = true; qtyInput.value = preset.dataset.qty; }

    var minus = section.querySelector('[data-qty-minus]'), plus = section.querySelector('[data-qty-plus]');
    minus && minus.addEventListener('click', function () { qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) - 1); });
    plus && plus.addEventListener('click', function () { qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1; });

    var form = section.querySelector('form[data-product-form]');
    var errorEl = section.querySelector('[data-form-error]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        addBtn.disabled = true; addLabel.textContent = W.strings.adding;
        if (errorEl) errorEl.hidden = true;
        fetch(W.routes.cart_add_url + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(idInput.value, 10), quantity: parseInt(qtyInput.value, 10) || 1 }] })
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.body.description || res.body.message || 'Could not add to cart');
            return Cart.refresh().then(Cart.open);
          })
          .catch(function (err) { if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; } })
          .finally(function () { addBtn.disabled = !variant.available; addLabel.textContent = variant.available ? addDefault : W.strings.soldOut; });
      });
    }

    // Sticky add-to-cart bar: show once the buy button scrolls out of view
    var sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var en = entries[0];
        var past = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', past);
        sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
        sticky.querySelector('a').tabIndex = past ? 0 : -1;
      }).observe(addBtn);
    }
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null,
    open: function () {
      if (!Cart.el) return;
      Cart.el.classList.add('is-open'); Cart.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var p = Cart.el.querySelector('.drawer__panel'); p && p.focus();
    },
    close: function () {
      if (!Cart.el) return;
      Cart.el.classList.remove('is-open'); Cart.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    refresh: function () {
      return fetch(W.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(Cart.render);
    },
    change: function (key, qty) {
      return fetch(W.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); }).then(Cart.render);
    },
    protectId: function () {
      var el = Cart.el && Cart.el.querySelector('[data-protect]');
      return el ? String(el.dataset.variantId) : null;
    },
    isProtect: function (it) { var pid = Cart.protectId(); return pid && String(it.variant_id || it.id) === pid; },
    render: function (cart) {
      var protectLine = null;
      var goods = cart.items.filter(function (it) { if (Cart.isProtect(it)) { protectLine = it; return false; } return true; });
      var count = goods.reduce(function (n, it) { return n + it.quantity; }, 0);
      document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = count; c.dataset.count = count; });
      var shown = { item_count: count, total_price: cart.total_price, items: goods };
      Cart.renderLines(shown);
      Cart.syncProtect(goods, protectLine);
      return cart;
    },
    optedOut: function () { try { return sessionStorage.getItem('wp-protect-off') === '1'; } catch (e) { return false; } },
    setOptOut: function (v) { try { if (v) sessionStorage.setItem('wp-protect-off', '1'); else sessionStorage.removeItem('wp-protect-off'); } catch (e) {} },
    busy: false,
    syncProtect: function (goods, protectLine) {
      var box = Cart.el && Cart.el.querySelector('[data-protect]');
      if (!box) return;
      var toggle = box.querySelector('[data-protect-toggle]');
      box.hidden = goods.length === 0;
      toggle.checked = !!protectLine;
      if (Cart.busy) return;
      var pid = Cart.protectId();
      if (goods.length === 0 && protectLine) { Cart.busy = true; Cart.change(protectLine.key, 0).finally(function () { Cart.busy = false; }); return; }
      if (goods.length > 0 && !protectLine && box.dataset.default === 'true' && !Cart.optedOut()) {
        Cart.busy = true;
        fetch(W.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(pid, 10), quantity: 1 }] }) })
          .then(function () { return Cart.refresh(); }).finally(function () { Cart.busy = false; });
        return;
      }
      if (protectLine && protectLine.quantity > 1) { Cart.busy = true; Cart.change(protectLine.key, 1).finally(function () { Cart.busy = false; }); }
    },
    toggleProtect: function (on) {
      var pid = Cart.protectId(); if (!pid) return;
      Cart.setOptOut(!on);
      Cart.busy = true;
      var p = on
        ? fetch(W.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: parseInt(pid, 10), quantity: 1 }] }) })
        : fetch(W.routes.cart_change_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: pid, quantity: 0 }) });
      p.then(function () { Cart.busy = false; return Cart.refresh(); }).catch(function () { Cart.busy = false; });
    },
    renderLines: function (cart) {
      if (!Cart.el) return cart;
      var items = Cart.el.querySelector('[data-cart-items]');
      var foot = Cart.el.querySelector('[data-cart-foot]');
      if (!cart.items.length) {
        items.innerHTML = '<p class="drawer__empty">' + W.strings.empty + '</p>';
        foot.hidden = true;
      } else {
        items.innerHTML = cart.items.map(function (it) {
          var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
          var variantTitle = it.product_has_only_default_variant ? '' : '<div class="line__variant">' + escapeHtml(it.variant_title || '') + '</div>';
          return '<div class="line" data-key="' + it.key + '">' +
            (img ? '<img src="' + img + '" alt="">' : '<span></span>') +
            '<div><a class="line__title" href="' + it.url + '">' + escapeHtml(it.product_title) + '</a>' + variantTitle +
            '<div class="qty"><button type="button" data-line-minus aria-label="Decrease">−</button><input type="number" value="' + it.quantity + '" min="0" aria-label="Quantity" data-line-qty><button type="button" data-line-plus aria-label="Increase">+</button></div>' +
            '<div><button type="button" class="line__remove" data-line-remove>Remove</button></div></div>' +
            '<div class="line__price">' + lineCompare(it) + '<span>' + formatMoney(it.final_line_price) + '</span></div></div>';
        }).join('');
        foot.hidden = false;
        Cart.el.querySelector('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);
      }
      var ship = Cart.el.querySelector('[data-ship]');
      var threshold = parseFloat(Cart.el.dataset.freeShipping);
      if (ship && threshold > 0) {
        var t = Math.round(threshold * 100), left = t - cart.total_price;
        ship.querySelector('[data-ship-text]').textContent = left <= 0 ? 'You’ve unlocked free shipping!' : 'You’re ' + formatMoney(left) + ' away from free shipping';
        ship.querySelector('[data-ship-bar]').style.width = Math.min(100, cart.total_price / t * 100) + '%';
      }
      return cart;
    },
    init: function () {
      Cart.el = document.getElementById('CartDrawer');
      if (!Cart.el) return;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); Cart.refresh().then(Cart.open); }
        if (e.target.closest('[data-drawer-close]')) Cart.close();
        var line = e.target.closest('.line');
        if (line) {
          var input = line.querySelector('[data-line-qty]'), q = parseInt(input.value, 10) || 0;
          if (e.target.closest('[data-line-minus]')) Cart.change(line.dataset.key, Math.max(0, q - 1));
          if (e.target.closest('[data-line-plus]')) Cart.change(line.dataset.key, q + 1);
          if (e.target.closest('[data-line-remove]')) Cart.change(line.dataset.key, 0);
        }
      });
      Cart.el.addEventListener('change', function (e) {
        if (e.target.matches('[data-protect-toggle]')) { Cart.toggleProtect(e.target.checked); return; }
        if (e.target.matches('[data-line-qty]')) Cart.change(e.target.closest('.line').dataset.key, Math.max(0, parseInt(e.target.value, 10) || 0));
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Cart.close(); });
    }
  };

  function lineCompare(it) {
    var map = (window.Warmpeak && window.Warmpeak.compare) || {};
    var c = map[it.variant_id || it.id || it.key];
    var ref = c ? c * it.quantity : it.original_line_price;
    return ref > it.final_line_price ? '<s>' + formatMoney(ref) + '</s>' : '';
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function initAll() {
    initReveal();
    initMenu();
    Cart.init();
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();

  // Theme editor: re-init sections when they reload
  document.addEventListener('shopify:section:load', function (e) {
    var s = e.target.querySelector('[data-product-section]');
    if (s) initProduct(s);
    e.target.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  });
})();
